import * as React from 'react';
const Avtart2 = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_2663_102630"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={2}
      width={24}
      height={24}
    >
      <circle cx={13.9118} cy={13.9118} r={11.9118} fill="#FC8F8F" />
    </mask>
    <g mask="url(#mask0_2663_102630)">
      <rect width={11.9118} height={11.9118} transform="translate(2 2)" fill="#1776CF" />
      <circle opacity={0.2} cx={5.11321} cy={5.11321} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={10.7988} cy={5.11321} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={5.11321} cy={10.7985} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={10.7988} cy={10.7985} r={1.75969} fill="white" />
      <rect width={11.9118} height={11.9118} transform="translate(13.9121 2)" fill="#1C974D" />
      <circle opacity={0.2} cx={17.0253} cy={5.11321} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={22.7109} cy={5.11321} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={17.0253} cy={10.7985} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={22.7109} cy={10.7985} r={1.75969} fill="white" />
      <rect width={11.9118} height={11.9118} transform="translate(2 13.9119)" fill="#E22525" />
      <circle opacity={0.2} cx={5.11321} cy={17.0251} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={10.7988} cy={17.0251} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={5.11321} cy={22.7101} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={10.7988} cy={22.7101} r={1.75969} fill="white" />
      <rect
        width={11.9118}
        height={11.9118}
        transform="translate(13.9121 13.9119)"
        fill="#FFDD65"
      />
      <circle opacity={0.2} cx={17.0253} cy={17.0251} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={22.7109} cy={17.0251} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={17.0253} cy={22.7104} r={1.75969} fill="white" />
      <circle opacity={0.2} cx={22.7109} cy={22.7104} r={1.75969} fill="white" />
      <rect
        x={12.3544}
        y={8.88958}
        width={3.11562}
        height={2.74691}
        rx={0.387906}
        fill="#FFDD65"
        stroke="#383434"
        strokeWidth={0.365088}
      />
      <path
        d="M11.8292 15.5177H15.9945C16.2087 15.5177 16.3824 15.6914 16.3824 15.9057V18.0046C16.3824 18.1826 16.2619 18.3356 16.0933 18.3747C14.5106 18.7416 13.4361 18.7423 11.7367 18.3698C11.5648 18.3322 11.4413 18.1776 11.4413 17.9974V15.9057C11.4413 15.6914 11.615 15.5177 11.8292 15.5177Z"
        fill="#FFDD65"
        stroke="#383434"
        strokeWidth={0.365088}
      />
      <path
        d="M11.2584 10.102H16.5645C17.3459 10.102 17.9793 10.7354 17.9793 11.5167V15.8139C17.9793 16.4887 17.5047 17.0694 16.8476 17.1767C14.7063 17.5265 13.1231 17.5195 10.9819 17.1737C10.3217 17.067 9.84368 16.4849 9.84368 15.8077V11.5167C9.84368 10.7354 10.4771 10.102 11.2584 10.102Z"
        fill="#FFDD65"
        stroke="#383434"
        strokeWidth={0.365088}
      />
      <path
        d="M11.2584 10.102H16.5645C17.3459 10.102 17.9793 10.7354 17.9793 11.5167V15.8139C17.9793 16.4887 17.5047 17.0694 16.8476 17.1767C14.7063 17.5265 13.1231 17.5195 10.9819 17.1737C10.3217 17.067 9.84368 16.4849 9.84368 15.8077V11.5167C9.84368 10.7354 10.4771 10.102 11.2584 10.102Z"
        stroke="#383434"
        strokeWidth={0.365088}
      />
      <path
        d="M10.3247 18.1713H17.5147C17.7745 18.1713 17.9984 18.3544 18.0499 18.609L20.1215 28.8418C20.1899 29.18 19.9314 29.4962 19.5863 29.4962H8.25315C7.90806 29.4962 7.64951 29.18 7.71798 28.8418L9.78953 18.609C9.84108 18.3544 10.0649 18.1713 10.3247 18.1713Z"
        fill="white"
        stroke="#383434"
        strokeWidth={0.323568}
      />
      <path
        d="M19.7323 19.6299C19.1773 18.8412 18.8223 18.6592 18.0538 18.6592L18.4178 20.459L18.973 23.2495L19.8739 27.5775C20.3269 26.9304 21.0872 26.7281 21.7344 27.1933C21.7344 27.1933 21.2086 22.6836 21.0872 22.2184C20.9659 21.7533 20.2162 20.3175 19.7323 19.6299Z"
        fill="#FFDD65"
        stroke="#383434"
        strokeWidth={0.323568}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.08997 19.6299C8.64497 18.8412 9 18.6592 9.76847 18.6592L9.40446 20.459L8.84926 23.2495L7.9484 27.5775C7.49541 26.9304 6.73503 26.7281 6.08789 27.1933C6.08789 27.1933 6.61369 22.6836 6.73503 22.2184C6.85636 21.7533 7.60611 20.3175 8.08997 19.6299Z"
        fill="#FFDD65"
        stroke="#383434"
        strokeWidth={0.323568}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5184 20.6768C11.5184 20.64 11.5483 20.6101 11.5851 20.6101H12.2523C12.2891 20.6101 12.319 20.64 12.319 20.6768V20.9837H12.8527V20.6768C12.8527 20.64 12.8825 20.6101 12.9194 20.6101H13.5865C13.6234 20.6101 13.6532 20.64 13.6532 20.6768V20.9837H14.1869V20.6768C14.1869 20.64 14.2168 20.6101 14.2536 20.6101H14.9208C14.9576 20.6101 14.9875 20.64 14.9875 20.6768V20.9837H15.5212V20.6768C15.5212 20.64 15.5511 20.6101 15.5879 20.6101H16.255C16.2919 20.6101 16.3217 20.64 16.3217 20.6768V20.9837L16.7087 20.9837C16.7382 20.9837 16.762 21.0076 16.762 21.0371V23.0651C16.762 23.0946 16.7382 23.1185 16.7087 23.1185H11.1315C11.102 23.1185 11.0781 23.0946 11.0781 23.0651V21.0371C11.0781 21.0076 11.102 20.9837 11.1315 20.9837L11.5184 20.9837V20.6768Z"
        fill="#E22525"
      />
      <ellipse
        cx={12.6775}
        cy={13.4623}
        rx={0.476784}
        ry={0.541444}
        transform="rotate(-8.25046 12.6775 13.4623)"
        fill="#383434"
      />
      <ellipse cx={12.6758} cy={13.2706} rx={0.189505} ry={0.189505} fill="white" />
      <path
        d="M13.0625 13.0242C12.9384 12.9109 12.5066 12.9261 12.1962 13.1006"
        stroke="#383434"
        strokeWidth={0.216578}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx={0.476784}
        cy={0.541444}
        rx={0.476784}
        ry={0.541444}
        transform="matrix(-0.98965 -0.1435 -0.1435 0.98965 15.8262 12.9949)"
        fill="#383434"
      />
      <ellipse cx={15.2618} cy={13.2901} rx={0.189505} ry={0.189505} fill="white" />
      <path
        d="M14.915 13.0242C15.0391 12.9109 15.471 12.9261 15.7813 13.1006"
        stroke="#383434"
        strokeWidth={0.216578}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3545 12.2506C13.2767 11.5053 11.851 11.7175 11.4082 12.4449C11.3972 12.463 11.4146 12.4834 11.4346 12.4763C12.0245 12.2672 12.3782 12.0855 13.3261 12.2758C13.3413 12.2789 13.3561 12.2661 13.3545 12.2506Z"
        fill="#383434"
      />
      <path
        d="M14.4907 12.2039C14.5941 11.3857 15.916 11.7539 16.4119 12.4836C16.4246 12.5022 16.4058 12.5243 16.385 12.5156C15.8152 12.2758 15.4765 12.0037 14.5197 12.2296C14.504 12.2333 14.4887 12.2199 14.4907 12.2039Z"
        fill="#383434"
      />
      <path
        d="M15.7203 14.5261L12.4355 15.0646C12.4355 15.0646 12.7369 15.9896 13.1419 16.3032C13.5469 16.6168 15.3141 16.2648 15.5172 15.9181C15.7203 15.5714 15.7203 14.9368 15.7203 14.5261Z"
        fill="#383434"
      />
      <path
        d="M15.7775 15.0286L12.628 15.4998L12.4297 15.0286L15.6534 14.5823L15.7775 15.0286Z"
        fill="white"
      />
      <path
        d="M13.7236 16.3571C13.8649 15.8903 14.3734 15.1708 15.2773 16.0276C15.089 16.1963 14.5146 16.4983 13.7236 16.3571Z"
        fill="#E22525"
      />
      <path
        d="M15.5172 15.9181C15.7203 15.5714 15.7203 14.9368 15.7203 14.5261C15.7203 14.5261 14.7268 14.7926 14.0799 14.8978C13.4329 15.003 12.4355 15.0646 12.4355 15.0646C12.4355 15.0646 12.7369 15.9896 13.1419 16.3032C13.5469 16.6168 15.3141 16.2648 15.5172 15.9181Z"
        stroke="#383434"
        strokeWidth={0.279056}
      />
      <path
        d="M15.7618 14.6023C15.7133 14.6002 15.6743 14.5612 15.6723 14.5127L15.6603 14.2345C15.6566 14.1491 15.7597 14.1038 15.8202 14.1642L16.1103 14.4543C16.1707 14.5148 16.1254 14.6179 16.04 14.6142L15.7618 14.6023Z"
        fill="#383434"
      />
      <path
        d="M12.4455 15.0105C12.4484 15.0591 12.4137 15.1018 12.3656 15.1088L12.0901 15.1493C12.0055 15.1617 11.9498 15.0638 12.0037 14.9975L12.2626 14.6791C12.3165 14.6128 12.4237 14.6473 12.4288 14.7326L12.4455 15.0105Z"
        fill="#383434"
      />
      <g clipPath="url(#clip0_2663_102630)">
        <path
          d="M9.71641 13.289V14.6633C9.41816 14.2537 8.79912 13.3882 8.70894 13.2032C8.61876 13.0182 8.67136 12.7019 8.70894 12.5669C8.60874 12.5232 8.37454 12.3049 8.23927 11.7809C8.104 11.2568 8.37078 10.7852 8.52107 10.6148C8.47598 10.1771 8.77783 9.8249 8.93439 9.70351C8.93439 8.87499 9.54811 8.57227 9.85496 8.52447L9.92344 7.98191C10.0147 7.69856 10.1763 7.19483 10.2819 6.93371C10.3735 6.70714 10.6041 6.86741 10.7287 6.93371C10.6974 6.85885 10.7417 6.67919 10.9822 6.55943C11.2227 6.43966 11.6084 6.50952 11.7712 6.55943C11.7963 6.42842 11.884 6.13271 12.0343 5.99796C12.1846 5.86321 12.7607 5.94182 13.03 5.99796C13.0488 5.81081 13.3681 5.49268 13.6887 5.49268C13.9452 5.49268 14.1204 5.82954 14.176 5.99796L14.6737 6.03446C14.8894 6.03446 15.0554 5.89362 15.1444 5.81305C15.2882 5.68281 15.4218 5.49268 15.6861 5.36681C16.3625 5.14223 16.4367 6.11027 16.4304 6.55943C16.9715 6.23004 17.3573 7.04601 17.4825 7.49517C17.9484 7.4802 18.4908 8.49954 18.7037 9.01108C19.5306 9.4228 19.3988 10.1691 19.643 11.162C19.8873 12.1548 18.8636 12.906 18.9166 13.4345C18.9591 13.8573 18.3755 14.8156 18.0784 15.2419L18.1845 13.4345C18.1208 13.431 17.9702 13.426 17.8768 13.4345C17.7601 13.445 17.6327 12.6946 17.3675 12.6946C17.1022 12.6946 17.1553 11.6905 17.134 11.162C17.1128 10.6335 16.2534 10.7075 15.9669 10.7392C15.6804 10.7709 15.0185 10.3173 14.9034 10.2547C14.7882 10.1921 14.5159 10.3277 14.3275 10.3173C14.1767 10.309 13.8388 10.215 13.6887 10.1691C13.6199 10.231 13.4225 10.3623 13.1839 10.392C12.9453 10.4217 12.5874 10.2558 12.4382 10.1691C12.1524 10.3053 11.4837 10.5851 11.096 10.6148C10.7082 10.6445 10.5615 10.8748 10.5367 10.9862C10.3503 12.6947 10.0147 12.509 10.0147 12.7319C10.0147 12.9102 9.81584 13.1776 9.71641 13.289Z"
          fill="#744C10"
        />
        <path
          d="M10.0147 12.7319C10.0147 12.9102 9.81584 13.1776 9.71641 13.289V14.6633C9.41816 14.2537 8.79912 13.3882 8.70894 13.2032C8.61876 13.0182 8.67136 12.7019 8.70894 12.5669C8.60874 12.5232 8.37454 12.3049 8.23927 11.7809C8.104 11.2568 8.37078 10.7852 8.52107 10.6148C8.47598 10.1771 8.77783 9.8249 8.93439 9.70351M10.0147 12.7319C10.0147 12.509 10.3503 12.6947 10.5367 10.9862C10.5615 10.8748 10.7082 10.6445 11.096 10.6148C11.4837 10.5851 12.1524 10.3053 12.4382 10.1691M10.0147 12.7319C9.76666 12.5417 9.27447 11.9951 9.28999 11.3303M12.4382 10.1691C12.5874 10.2558 12.9453 10.4217 13.1839 10.392C13.4225 10.3623 13.6199 10.231 13.6887 10.1691M12.4382 10.1691C12.747 9.89412 13.3645 9.20794 13.3645 8.66304M13.6887 10.1691C13.8388 10.215 14.1767 10.309 14.3275 10.3173C14.5159 10.3277 14.7882 10.1921 14.9034 10.2547M13.6887 10.1691C14.0133 9.96988 14.7105 9.4864 14.9034 9.14623M14.9034 10.2547C15.0185 10.3173 15.6804 10.7709 15.9669 10.7392M14.9034 10.2547C15.3284 10.0978 16.229 9.67195 16.4304 9.22354M15.9669 10.7392C16.2534 10.7075 17.1128 10.6335 17.134 11.162C17.1553 11.6905 17.1022 12.6946 17.3675 12.6946M15.9669 10.7392C16.3137 10.6203 17.0549 10.2899 17.245 9.91934M17.3675 12.6946C17.6327 12.6946 17.7601 13.445 17.8768 13.4345C17.9702 13.426 18.1208 13.431 18.1845 13.4345M17.3675 12.6946C17.7106 12.5669 17.7919 11.8529 17.8768 11.3303M18.1845 13.4345L18.0784 15.2419C18.3755 14.8156 18.9591 13.8573 18.9166 13.4345C18.8636 12.906 19.8873 12.1548 19.643 11.162C19.3988 10.1691 19.5306 9.4228 18.7037 9.01108M18.1845 13.4345C18.3576 13.242 18.7037 12.7141 18.7037 12.142M18.7037 9.01108C18.4908 8.49954 17.9484 7.4802 17.4825 7.49517M18.7037 9.01108C18.7035 9.17504 18.6196 9.5424 18.5449 9.70351M17.4825 7.49517C17.3573 7.04601 16.9715 6.23004 16.4304 6.55943M17.4825 7.49517C17.4707 7.60998 17.4312 7.86805 17.3675 7.98191M16.4304 6.55943C16.4367 6.11027 16.3625 5.14223 15.6861 5.36681C15.4218 5.49268 15.2882 5.68281 15.1444 5.81305C15.0554 5.89362 14.8894 6.03446 14.6737 6.03446L14.176 5.99796M16.4304 6.55943C16.4467 6.68682 16.445 6.97778 16.3082 7.12241M14.176 5.99796C14.1204 5.82954 13.9452 5.49268 13.6887 5.49268C13.3681 5.49268 13.0488 5.81081 13.03 5.99796M14.176 5.99796C14.2265 6.10636 14.3275 6.37041 14.3275 6.55943M13.03 5.99796C12.7607 5.94182 12.1846 5.86321 12.0343 5.99796C11.884 6.13271 11.7963 6.42842 11.7712 6.55943M13.03 5.99796C12.9193 6.15497 12.7199 6.53433 12.8074 6.7957M11.7712 6.55943C11.6084 6.50952 11.2227 6.43966 10.9822 6.55943C10.7417 6.67919 10.6974 6.85885 10.7287 6.93371M11.7712 6.55943C11.7019 6.65893 11.5841 6.91082 11.6673 7.12241M10.7287 6.93371C10.6041 6.86741 10.3735 6.70714 10.2819 6.93371C10.1763 7.19483 10.0147 7.69856 9.92344 7.98191L9.85496 8.52447M10.7287 6.93371C10.7017 7.04729 10.7862 7.28131 10.8508 7.39805M9.85496 8.52447C9.54811 8.57227 8.93439 8.87499 8.93439 9.70351M9.85496 8.52447C9.70935 8.7261 9.61633 9.65797 9.85496 9.91934M8.93439 9.70351C8.95505 9.80931 9.15515 10.2734 9.28999 10.392"
          stroke="#422B09"
          strokeWidth={0.379011}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2663_102630">
        <rect width={13.6444} height={12.1825} fill="white" transform="translate(6.9834 5.06274)" />
      </clipPath>
    </defs>
  </svg>
);
export default Avtart2;
